import axios from "../custom-axios/tvchannels";

class MunicipalityRepository {
    fetchMunicipalities = (selectedCity, language) => {
        return  axios.get(`/municipality/${selectedCity}?language=${language}`)
    }
}

export default new MunicipalityRepository()